import { Star } from "lucide-react";
import { useState } from "react";

export default function RatingStars({ value = 0, max = 5, size = 18, interactive = false, onRate, disabled = false, "data-testid": testId }) {
  const [hover, setHover] = useState(0);
  const display = hover || value || 0;

  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {Array.from({ length: max }, (_, i) => {
        const n = i + 1;
        const filled = n <= display;
        const half = !filled && n - 0.5 <= display;
        return (
          <button
            key={n}
            type="button"
            disabled={!interactive || disabled}
            onMouseEnter={() => interactive && setHover(n)}
            onMouseLeave={() => interactive && setHover(0)}
            onClick={() => interactive && onRate?.(n)}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            data-testid={testId ? `${testId}-${n}` : undefined}
            className={`transition-transform ${interactive ? "cursor-pointer hover:scale-110" : "cursor-default"} ${disabled ? "opacity-50" : ""}`}
          >
            <Star
              size={size}
              className={filled || half ? "text-hotpink" : "text-white/25"}
              fill={filled ? "currentColor" : half ? "url(#half-grad)" : "none"}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient id="half-grad" x1="0" x2="1" y1="0" y2="0">
            <stop offset="50%" stopColor="currentColor" />
            <stop offset="50%" stopColor="transparent" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
